var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#B6BEC5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 0C5.67728 0 6.125 0.447715 6.125 1V5.125C6.125 5.67728 5.67728 6.125 5.125 6.125H1C0.447715 6.125 0 5.67728 0 5.125V1C0 0.447715 0.447715 0 1 0H5.125ZM5.125 7.875C5.67728 7.875 6.125 8.32271 6.125 8.875V13C6.125 13.5523 5.67728 14 5.125 14H1C0.447715 14 0 13.5523 0 13V8.875C0 8.32271 0.447715 7.875 1 7.875H5.125ZM14 1C14 0.447715 13.5523 0 13 0H8.875C8.32271 0 7.875 0.447715 7.875 1V5.125C7.875 5.67728 8.32271 6.125 8.875 6.125H13C13.5523 6.125 14 5.67728 14 5.125V1ZM13 7.875C13.5523 7.875 14 8.32271 14 8.875V13C14 13.5523 13.5523 14 13 14H8.875C8.32271 14 7.875 13.5523 7.875 13V8.875C7.875 8.32271 8.32271 7.875 8.875 7.875H13Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/Cards.f302a4af.svg";
export { ForwardRef as ReactComponent };